import { usePage } from "@inertiajs/react"
import { UserLayout } from "@/components/layouts/user-layout"
import { CartScreen } from "@/features/user/cart-screen"
import type { BillDetailed, DinerSummary } from "@/features/user/types"

type Props = {
  diner: DinerSummary
  bill: BillDetailed
}

export default function UserBillsShow() {
  const { diner, bill } = usePage<Props>().props

  return (
    <UserLayout wide fillsViewport>
      <CartScreen bill={bill} serviceContext={diner?.serviceContext} />
    </UserLayout>
  )
}
